export const getStatusLabel = (status) => {
    switch (status) {
        case 1:
            return <span className="custom-badge status-orange">Pending</span>
        case 2:
            return <span className="custom-badge status-yellow">Verified</span>
        case 3:
            return <span className="custom-badge status-green">Approved</span>;
        case 4:
            return <span className="custom-badge status-pink">Rejected</span>;
        default:
            return 'Unknown';
    }
};


